import {Button} from "antd";

export default function AddItem({ api: VeriflytTicketTemplateSelectApi }){
    function onClicked(){
        VeriflytTicketTemplateSelectApi.openPanel();
    }

    return (
        <Button
            size="small"
            type="link"
            icon="add"
            onClick={onClicked}
            block
        >Add item</Button>
    )

}